// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pg_a bhc_ea bhc_kb bhc_js bhc_a bhc_j bhc_sm bhc_sn","SearchPanel__icon":"pg_b bhc_vm bhc_hg bhc_ss bhc_uy","SearchPanel__input":"pg_c bhc_iz bhc_eb bhc_z"};